// extracted by mini-css-extract-plugin
export default {"Container":"SimpleLayout__Container__qazdW","ContentWrapper":"SimpleLayout__ContentWrapper__1pL0W"};